import { Component, ElementRef,  OnInit,  Input,  ViewChild, SimpleChange } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

import { Chart, registerables } from 'chart.js';

import { DatePipe } from '@angular/common';
import { DataGrafica } from 'src/app/models/data-grafica';
import { DataToGraf } from 'src/app/models/data-graf';
import * as moment from 'moment';

const datePipe = new DatePipe('en-US');

const data = {
  labels: ['Apples', 'Oranges', 'Mixed Fruit'],
  datasets: [
    {
      label: '',
      data: [0, 50, 45, 100],
      backgroundColor: 'rgba(40,125,200,.5)',
      borderColor: 'rgb(40,100,200)',
      fill: true,
      lineTension: 0.4,
      radius: 3,
    },
    // {
    //   label: 'Oranges',
    //   data: [30, 90, 111, 20],
    //   backgroundColor: 'rgba(75,10,125,.5)',
    //   borderColor: 'rgb(75,10,125)',
    //   fill: true,
    //   lineTension: 0.2,
    //   radius: 5,
    // },
  ],
};

const options = {
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    title: {
      display: true,
      text: ''
    }
  },
  title: {
    display: true,
    position: 'top',
    text: ' ',
    fontSize: 12,
    fontColor: '#666',
  },
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      fontColor: '#999',
      fontSize: 14,
    },
    scales: {
      x:{
        display: true,
        title: {
          display: true,
          text: ""
        }
      },
      y:{
        display: true,
        title: {
          display: true,
          text: ""
        }
      },
    }
  },
};

const temp: string = "TEMPERATURA";
const hume: string = "HUMEDAD";
const lumi: string = "LUMINOSIDAD";

@Component({
  selector: 'app-grafica-line',
  templateUrl: './grafica-line.component.html',
  styleUrls: ['./grafica-line.component.scss']
})


export class GraficaLineComponent implements  OnInit {
  
  DEBUG: boolean = false;

  constructor(private elementRef: ElementRef, private _cdref:ChangeDetectorRef) {
    Chart.register(...registerables);
  }

  //cargamos la opcion seleccionada por el radiobutton

  @Input() dataGrafica: DataGrafica;
  @Input() flagCargaGrafica: boolean;
  dataToGraf: DataToGraf;

// Input para la fecha EJEX

  name = 'ChartJs';
  chart: any;
  ctx: any = document.getElementById('lineChart') as HTMLElement;
  // flagCargaGrafica: boolean = true;
  flagChart: boolean = false;

  @ViewChild('lineChart', { static: false }) private chartRef: ElementRef;


  timeIni: number;
  timeFin: number;
  tipoGrafica: string;
  data: number[] = [];
  labels: any[] = [];

  flagViewGraf: boolean = false;

  ngOnInit(){
    // console.log('[Grafica LINE] ngOnInit');
    this.flagCargaGrafica = true;
    this.ctx = document.getElementById('lineChart') as HTMLElement;
    
    
    // this._cdref.detectChanges();

    // this.createChart();
  }


  ngAfterViewInit() {
    if(this.DEBUG){
      console.log('[Grafica LINE] ngAfterViewInit');
      console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);
    }
    this.ctx = document.getElementById('lineChart') as HTMLElement;
    
    
    // this._cdref.detectChanges();

    // this.createChart();

    
  }

  ngOnChanges(changes: SimpleChange): void {
    this.flagCargaGrafica = false;
    this.ctx = document.getElementById('lineChart') as HTMLElement;
    
    
    if(this.dataGrafica != undefined){
      
          //Obtenemos los datos pasados a la gráfica
      if(this.DEBUG){
        console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);
        console.log('[Grafica LINE]  value changed' + this.tipoGrafica);
        console.log(this.dataGrafica);
      }

      this.timeIni = this.dataGrafica.timeIni; 
      this.timeFin = this.dataGrafica.timeFin;
      this.tipoGrafica = this.dataGrafica.tipoGrafica;
      
  
      // Modificamos las opciones de los ejes de la grafica dependiendo de los datos recibidos
      this.confDataGrafica();
    }else{
      // this.flagCargaGrafica = true;
    }

    // if (this.chart){
    //   console.log("La grafica existe y la limpiamos");
    //   this.chart.clear();
    //   this.chart.destroy();
    // }
    // this.configGrafica();

    
  }

  confDataGrafica(){
    this.flagCargaGrafica = false;

    //Limpiamos los valores
    this.data = [];
    this.labels = [];

    let horaIni;
    let horaFin;
    let tiempo;
    horaIni = datePipe.transform(this.dataGrafica.data.timestamp[0], 'HH:mm dd/MM/YYY');
    horaFin = datePipe.transform(this.dataGrafica.data.timestamp[this.dataGrafica.data.timestamp.length-1], 'HH:mm dd/MM/YYY');

    if(this.DEBUG){
      console.log(horaIni);
      console.log(horaFin);
    }

    this.data = this.dataGrafica.data.data;
    this.asyncMethodConvertTime(); 

  }

  async asyncMethodConvertTime() {
    if(this.DEBUG){
      console.log(this.labels);
    }

    let tiempo;
    for (let i = 0; i < this.dataGrafica.data.timestamp.length; i++) {
      if(this.dataGrafica.data.timestamp[i] != undefined){
        //console.log(moment(this.dataGrafica.data.timestamp[i]).format("HH:mm"));
        tiempo = moment(this.dataGrafica.data.timestamp[i]).format("HH:00");
        if (tiempo == "00:00"){
          this.labels.push(moment(this.dataGrafica.data.timestamp[i]).format("DD/MM/YYYY"));
        }else{
          this.labels.push(moment(this.dataGrafica.data.timestamp[i]).format("HH:00"));
        }
        
      }
    }
    if(this.DEBUG){
      console.log("asyncMethodConvertTime");
      console.log(this.labels);
    }

    if (this.chart){
      if(this.DEBUG){
        console.log("La grafica existe y la limpiamos");
      }
      
      this.chart.clear();
      this.chart.destroy();
    }
    this.configGrafica();
  }

  public configGrafica(){
    //cargamos la opcion seleccionada por el radiobutton
    // Seleccionamos la gráfica que queremos con las opciones personalizadas de cada una
    switch(this.tipoGrafica) { 
      case temp: { 
         //TEMPERATURA
         options.legend.scales.y.title.text = "°C";  
         data.datasets[0].data = this.data; //Datos eje Y
         data.labels = this.labels; //Datos eje X
         data.datasets[0].backgroundColor = '#FF98002A';
         data.datasets[0].borderColor = '#FF9800';
        //  data.datasets[0].label = this.tipoGrafica;
        //  options.title.text = this.tipoGrafica;
         options.plugins.title.text = this.tipoGrafica;
         this.flagViewGraf = true;
         break; 
      } 
      case hume: { 
         //HUMEDAD
         options.legend.scales.y.title.text = "%"; 
         data.datasets[0].data = this.data;//Datos eje Y
         data.labels = this.labels; //Datos eje X
         data.datasets[0].backgroundColor = '#1E88E52A';
         data.datasets[0].borderColor = '#1E88E5';
        //  data.datasets[0].label = this.tipoGrafica;
        //  options.title.text = this.tipoGrafica;
         options.plugins.title.text = this.tipoGrafica;
         this.flagViewGraf = true;
         break; 
      } 
      case lumi: { 
        //LUMINOSIDAD; 
        options.legend.scales.y.title.text = "lum";
        data.datasets[0].data = this.data;//Datos eje Y
        data.labels = this.labels; //Datos eje X
        data.datasets[0].backgroundColor = '#FDD8352A';
        data.datasets[0].borderColor = '#FDD835';
        // data.datasets[0].label = this.tipoGrafica;
        // options.title.text = this.tipoGrafica;
        options.plugins.title.text = this.tipoGrafica;
        this.flagViewGraf = true;
        break; 
      } 
      default: { 
         //statements; 
         break; 
      } 
   }

   this.createChart();
      
  }

  createChart(){
    this.flagCargaGrafica = true;
    console.log("FLAG CARGAR GRAFICA: " + this.flagCargaGrafica);
    // this.flagViewGraf = true;
    this.chart = new Chart(this.ctx, {
      type: 'line',
      data: data,
      options: options,
    });
  }

}
